import { useDispatch } from "react-redux";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import type { ApiError } from "@entrilia/shared/api/types";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";
import { logError } from "@entrilia/shared/logging";
import biApi from "../../../../../../../../../api/biApi";
import type { MeasureSubgroup, MeasureSubgroupWithMeasures } from "../../../../../../../../../api/types/svTypes.ts";
import { createMetaDataAction } from "../../../../../store/utils/storeUtils";
import { validateSubgroupName } from "../utilities/measureSubgroups";
import SubgroupNameDialog from "./SubgroupNameDialog";

const createMeasureSubgroup = withErrorHandling(biApi.createMeasureSubgroup);

interface Props {
  group: string;
  existingSubgroups: MeasureSubgroup[];
  onCreated?: (subgroup: MeasureSubgroup) => void;
  onClose: () => void;
}

const NewSubgroupDialog = ({ group, existingSubgroups, onCreated, onClose }: Props) => {
  const dispatch = useDispatch();
  const { sendNotification, sendNotificationError } = useNotificationContext();

  const handleSaved = ({ subgroup }: MeasureSubgroupWithMeasures) => {
    dispatch(createMetaDataAction("addMeasureSubgroup", subgroup));
    sendNotification("New subgroup created successfully");
    onCreated?.(subgroup);
  };

  const handleSaveError = (error: ApiError) => {
    logError(error, "[NewSubgroupDialog] createMeasureSubgroup");
    sendNotificationError(error.message);
  };

  return (
    <SubgroupNameDialog
      title="New Subgroup"
      validateName={(name) => validateSubgroupName(name, existingSubgroups)}
      onSave={(name) => createMeasureSubgroup({ group, name })}
      onSaved={handleSaved}
      onSaveError={handleSaveError}
      onClose={onClose}
    />
  );
};

export default NewSubgroupDialog;
